(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ossomosso-collection-products"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ossomosso-variant-grid]').forEach((grid) => {
    const groups = new Map();
    [...grid.children].forEach((card) => {
      const handle = card.dataset.productHandle;
      groups.set(handle, [...(groups.get(handle) || []), card]);
    });

    const random = (items) => items.sort(() => Math.random() - 0.5);
    groups.forEach(random);

    let previousHandle;
    while ([...groups.values()].some((cards) => cards.length)) {
      const available = random([...groups.entries()].filter(([handle, cards]) => cards.length && handle !== previousHandle));
      const fallback = [...groups.entries()].filter(([, cards]) => cards.length);
      const [handle, cards] = available[0] || fallback[0];
      grid.append(cards.pop());
      previousHandle = handle;
    }
  });

  } catch(e) { console.error(e); }
})();
})();
